export default __webpack_public_path__ + "static/media/Book.762b8598.svg";